import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const yogaSteps = [
  {
    number: 1,
    title: 'Start with Intention',
    description: 'Set a clear intention for your practice. What energy do you want to cultivate today?'
  },
  {
    number: 2,
    title: 'Flow with Energy',
    description: 'Move through the poses with vitality and enthusiasm. Let the sequence energize your body and mind.'
  },
  {
    number: 3,
    title: 'Connect Breath to Movement',
    description: 'Use dynamic breathing that matches the pace of your movement. Inhale to expand, exhale to power through transitions.'
  },
  {
    number: 4,
    title: 'Finish with Gratitude',
    description: 'End your practice with appreciation for your body\'s strength and the energy you\'ve cultivated.'
  }
];

const YogaFlowSession5: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Yoga Flow Session 5',
      description: 'Completed Yoga Flow Session 5.',
      image: require('../assets/yoga.png').default || require('../assets/yoga.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/yoga-flow');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 5: Energy Flow</h1>
              <p className="session-description">
                Ignite your inner fire and boost your vitality with this energizing yoga sequence. Perfect for starting your day with renewed energy and focus.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/0o0kNeOyH98"
                  title="Session 5: Energy Flow"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Practice</h2>
                <div className="session-steps">
                  {yogaSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default YogaFlowSession5;

